/** @module Sourcing/MassActionSupplierItems */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/locale",
	"underscore",
	"./_MassActionsMixin"
], function(declare,Controller,locale,_,_MassActionsMixin) {

	return declare([Controller,_MassActionsMixin], {

		/**
		 * @override
		 * Generate success message
		 */
		postProcessSuccess: function() {
			var resource = this.m_action.m_id.replace("SupplierItems","Quote_Success");
			this.massActionErrors = this.massActionErrors || [];
			var numTotalQuotes = this.m_formData.getSelectedNodes().length;
			var numSuccessQuotes = numTotalQuotes - this.massActionErrors.length;
			this.massActionSuccessMessage = locale.resource(resource, [numSuccessQuotes]);

			// display "Some Failed" message
			if (this.massActionErrors.length > 0) {
				var statusMsg = locale.resource("MassActionQuote_SomeFailed", [numSuccessQuotes, numTotalQuotes]);
				for (var i = 0; i < this.massActionErrors.length; i ++) {
					var quote = this.m_cache.getNode(this.massActionErrorCNLs[i]);
					// sometimes the quote is the actual quote or the revision
					if (quote.$Type == "SupplierItemRevision" || quote.$Type == "FoodSupplierItemRevision") {
						quote = this.m_cache.getNode(quote.__Parent__);
					}
					var product = this.m_cache.getPathNode(quote, "Child:__Parent__/Child:__Parent__/Child:__Parent__");
					statusMsg += "\n" + locale.resource("MassActionQuote_EachError", [product.$Name, quote.$Name, this.massActionErrors[i]]);
				}

				this.displayErrorDialog({
					title: locale.resource("MassActionQuote_Title"),
					message: statusMsg,
					onResponse: function() {}
				});
			}
			return this.inherited(arguments);
		}
	});
});
